import React, { useState } from 'react'
import { Input, message as AntMessage } from 'antd'
import { confirmBase } from 'utils/ui'
import ResourceService from 'api/Resource'

const useShareExtensionRequest = (resourceId, t, messageRef) => {
  const handleShareAgain = () => {
    const ShareExtensionContent = () => {
      const [message, setMessage] = useState('')

      return (
        <div>
          <div style={{ marginBottom: '16px' }}>{t('record.confirm.shareAgain')}</div>
          <Input.TextArea
            rows={4}
            placeholder={t('record.placeholder.shareExtensionMessage')}
            value={message}
            onChange={(e) => {
              const { value } = e.target
              setMessage(value)
              messageRef.current = value
            }}
          />
        </div>
      )
    }

    confirmBase({
      title: t('record.button.shareAgain'),
      content: <ShareExtensionContent />,
      okText: t('common.button.ok'),
      onOk: async () => {
        try {
          const response = await ResourceService.shareExtensionRequest(resourceId, {
            message: messageRef.current,
          })

          if (response?.code === 200) {
            AntMessage.success(t('record.result.shareExtensionRequestSuccess'))
          } else {
            AntMessage.error(t(`workspace.error.${response.code}`))
          }

          messageRef.current = ''
        } catch (error) {
          console.error('error: ', error)
          if (error.code === 459 && error.data?.retry_after_seconds) {
            const totalSeconds = error.data.retry_after_seconds
            const minutes = Math.floor(totalSeconds / 60)
            const seconds = totalSeconds % 60
            const timeStr = minutes > 0
              ? t('common.time.minutesSeconds', { minutes, seconds })
              : t('common.time.seconds', { seconds })
            AntMessage.error(`${t('workspace.error.459')} ${t('common.time.remainingTime', { time: timeStr })}`)
          } else {
            AntMessage.error(t(`workspace.error.${error.code}`))
          }
        }
      },
      onCancel: () => {
        messageRef.current = ''
      },
    })
  }

  return handleShareAgain
}

export default useShareExtensionRequest
